import { Link } from 'react-router-dom';

export default function LandingPage() {
  return (
    <div style={{ fontFamily: 'sans-serif', backgroundColor: 'rgb(249, 250, 251)', minHeight: '100vh' }}>

      {/* Floating pill nav */}
      <header style={{ textAlign: 'center', padding: 0, position: 'fixed', width: '100%', zIndex: 50 }}>
        <nav style={{
          display: 'inline-flex',
          alignItems: 'center',
          margin: '1rem auto',
          padding: '0 0.25rem',
          borderRadius: '1rem',
          boxShadow: '0 1px 3px black',
          backgroundColor: 'white',
          gap: '0.25rem',
        }}>
          <Link to="/" style={{
            display: 'inline-block',
            margin: '0.75rem 0.75rem 0.75rem 1rem',
            textDecoration: 'none',
            fontWeight: 700,
            fontSize: '1.1rem',
            color: 'rgb(37, 99, 235)',
            letterSpacing: '-0.01em',
          }}>
            Resume Foundry
          </Link>
          <Link to="/login" style={{
            display: 'inline-block',
            margin: '0.75rem 0.25rem 0.75rem 0.75rem',
            padding: '0.25rem 0.75rem',
            borderRadius: '0.5rem',
            textDecoration: 'none',
            color: 'rgb(55, 65, 81)',
            fontSize: '0.95rem',
            boxShadow: 'rgba(0,0,0,0.1) 0px 1px 3px 0px, rgba(0,0,0,0.1) 0px 1px 2px -1px',
          }}>
            Login
          </Link>
          <Link to="/signup" style={{
            display: 'inline-block',
            margin: '0.75rem 1rem 0.75rem 0.25rem',
            padding: '0.25rem 0.75rem',
            borderRadius: '0.5rem',
            textDecoration: 'none',
            color: 'white',
            backgroundColor: 'rgb(59, 60, 61)',
            fontSize: '0.95rem',
            boxShadow: 'rgba(0,0,0,0.1) 0px 1px 3px 0px, rgba(0,0,0,0.1) 0px 1px 2px -1px',
          }}>
            Register
          </Link>
        </nav>
      </header>

      {/* Centered copy */}
      <main style={{
        textAlign: 'center',
        maxWidth: '48rem',
        margin: '0 auto',
        paddingTop: '8rem',
        paddingLeft: '1.5rem',
        paddingRight: '1.5rem',
      }}>
        <h1 style={{ fontSize: '4rem', fontWeight: 800, lineHeight: 1.1, margin: '0 0 1.5rem', letterSpacing: '-0.02em' }}>
          Your resume, ready for any job.
        </h1>
        <p style={{ fontSize: '1.125rem', color: 'rgb(75, 85, 99)', lineHeight: 1.7, margin: '0 auto 2.5rem', maxWidth: '36rem' }}>
          Resume Foundry keeps every career highlight you've earned in one place.
          Paste a job posting and get the right bullets—written for what they're actually asking for.
        </p>
        <div style={{ margin: '2.5rem 0' }}>
          <Link to="/signup" style={{
            display: 'inline-block',
            textDecoration: 'none',
            padding: '1rem 1.75rem',
            borderRadius: '0.5rem',
            color: 'white',
            backgroundImage: 'linear-gradient(to top, rgb(37, 99, 235), rgb(59, 130, 246))',
            fontWeight: 600,
            fontSize: '1rem',
            boxShadow: 'rgba(0,0,0,0.1) 0px 1px 3px 0px, rgba(0,0,0,0.1) 0px 1px 2px -1px',
          }}>
            Get started free
          </Link>
        </div>
      </main>

      {/* Screenshots */}
      <section style={{
        maxWidth: '72rem',
        margin: '4rem auto 5rem',
        padding: '0 1.5rem',
      }}>
        <p style={{
          textAlign: 'center',
          fontSize: '0.8rem',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: 'rgb(156, 163, 175)',
          marginBottom: '2rem',
        }}>
          See it in action
        </p>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '1.5rem',
        }}>
          <figure style={{ margin: 0 }}>
            <img
              src="/images/matching.png"
              alt="Resume bullets ranked by match percentage against a job posting"
              style={{
                width: '100%',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0,0,0,0.08)',
                boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
                display: 'block',
              }}
            />
            <figcaption style={{
              marginTop: '0.75rem',
              textAlign: 'center',
              fontSize: '0.875rem',
              color: 'rgb(107, 114, 128)',
            }}>
              Your highlights, ranked by relevance to the role
            </figcaption>
          </figure>
          <figure style={{ margin: 0 }}>
            <img
              src="/images/breakdown.png"
              alt="Profile match score with strengths and gaps analysis"
              style={{
                width: '100%',
                borderRadius: '0.75rem',
                border: '1px solid rgba(0,0,0,0.08)',
                boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
                display: 'block',
              }}
            />
            <figcaption style={{
              marginTop: '0.75rem',
              textAlign: 'center',
              fontSize: '0.875rem',
              color: 'rgb(107, 114, 128)',
            }}>
              Strengths, gaps, and your overall profile match
            </figcaption>
          </figure>
        </div>
      </section>

    </div>
  );
}
